import { getUserPermission, getPermissionList } from '@/api/api'
import { Storage } from '@/utils/storage'
import { decrypt, filterMenu } from '@/utils/tool'
import { ISCLOSEMENU, ADMIN_NAME } from '@/config/menu'

// 获取全部路由
export function useMenuAllApi() {
	return new Promise((resolve, reject) => {
		getPermissionList({ page: 1, size: 500 })
		.then((res: any) => {
			const hideCode = ['dateAnalysis','packingM', 'newReceipt', 'receiptDetails','werehouse'];
			res.data.data = res.data.data.filter(i => !hideCode.includes(i.langcode));
			resolve(res.data);
		})
		.catch(() => {
			resolve([]);
		})
	})
}

// 获取当前路由
export function useMenuNavApi() {
	return new Promise((resolve, reject) => {
		if(Storage.getItem('user_system') == 2 && false){ // 这里启用下面的权限获取
			resolve([]);
		}else{
			let login_username = Storage.getItem('login_username')?decrypt(Storage.getItem('login_username')):'';
			console.log(login_username);
			if(Storage.getItem('router_key')){
				getUserPermission({ id: decrypt(Storage.getItem('router_key')) })
				.then((res: any) => {
			        const hideCode = ['dateAnalysis','packingM', 'newReceipt', 'receiptDetails','werehouse'];
                    res.data = res.data.filter(i => !hideCode.includes(i.langcode));
					let data = filterMenu(res)
					// 2022-11-07  21:39:27-以业模块配置只有管理员才能看
					// if(ISCLOSEMENU && !ADMIN_NAME.includes(login_username) && data.some((item: any) => item.route == 'PagenSystem/zymenu/index')){
					// 	data.splice(data.findIndex((item: any) => item.route == 'PagenSystem/zymenu/index'),1)
					// }
					// if(data.some((item: any) => item.route == 'base')){
					// 	data.splice(data.findIndex((item: any) => item.route == 'base'),1)
					// }
					// 基础权限不渲染页面
					resolve(data);
				})
				.catch((err) => {
                    console.log(err);
                })
				
			}else{
				resolve([]);
			}
		}
		// resolve({
		// 	"code": 0,
		// 	"msg": "success",
		// 	"data": [
		// 		{
		// 			"id": 4,
		// 			"name": "审核管理",
		// 			"url": null,
		// 			"openStyle": 0,
		// 			"icon": "icon-setting",
		// 			"children": [
		// 				{
		// 					"id": 401,
		// 					"name": "待审核学生",
		// 					"url": "manageExamine/student/index",
		// 					"openStyle": 0,
		// 					"icon": "icon-file-text"
		// 				},
		// 				{
		// 					"id": 402,
		// 					"name": "待审核企业",
		// 					"url": "manageExamine/company/index",
		// 					"openStyle": 0,
		// 					"icon": "icon-file-text"
		// 				}
		// 			]
		// 		},
		// 		{
		// 			"id": 2,
		// 			"name": "学生列表",
		// 			"url": "manageStudent/index",
		// 			"openStyle": 0,
		// 			"icon": "icon-unorderedlist",
		// 			"children": []
		// 		},
		// 		{
		// 			"id": 3,
		// 			"name": "企业列表",
		// 			"url": "manageCompany/index",
		// 			"openStyle": 0,
		// 			"icon": "icon-unorderedlist"
		// 		},
		// 		{
		// 			"id": 6,
		// 			"name": "学校列表",
		// 			"url": "manageSchool/index",
		// 			"openStyle": 0,
		// 			"icon": "icon-unorderedlist"
		// 		},
		// 		{
		// 			"id": 7,
		// 			"name": "订单列表",
		// 			"url": "manageOrder/index",
		// 			"openStyle": 0,
		// 			"icon": "icon-unorderedlist"
		// 		},
		// 		{
		// 			"id": 8,
		// 			"name": "上岗列表",
		// 			"url": "manageWork/index",
		// 			"openStyle": 0,
		// 			"icon": "icon-unorderedlist"
		// 		},
		// 		{
		// 			"id": 9,
		// 			"name": "财务管理",
		// 			"url": null,
		// 			"openStyle": 0,
		// 			"icon": "icon-setting",
		// 			"children": [
		// 				{
		// 					"id": 901,
		// 					"name": "应收款列表",
		// 					"url": "manageFinance/receivable/index",
		// 					"openStyle": 0,
		// 					"icon": "icon-file-text"
		// 				},
		// 				{
		// 					"id": 902,
		// 					"name": "收款单管理",
		// 					"url": "manageFinance/receipt/index",
		// 					"openStyle": 0,
		// 					"icon": "icon-file-text"
		// 				},
		// 				{
		// 					"id": 903,
		// 					"name": "退款管理",
		// 					"url": "manageFinance/refund/index",
		// 					"openStyle": 0,
		// 					"icon": "icon-file-text"
		// 				},
		// 				{
		// 					"id": 904,
		// 					"name": "业绩情况",
		// 					"url": "manageFinance/achievement/index",
		// 					"openStyle": 0,
		// 					"icon": "icon-file-text"
		// 				}
		// 			]
		// 		},
		// 		{
		// 			"id": 1,
		// 			"name": "系统管理",
		// 			"url": null,
		// 			"openStyle": 0,
		// 			"icon": "icon-setting",
		// 			"children": [
		// 				{
		// 					"id": 15,
		// 					"name": "部门设置",
		// 					"url": "manageSystem/department/index",
		// 					"openStyle": 0,
		// 					"icon": "icon-edit-square"
		// 				},
		// 				{
		// 					"id": 19,
		// 					"name": "员工及权限设置",
		// 					"url": "manageSystem/staff/index",
		// 					"openStyle": 0,
		// 					"icon": "icon-edit-square"
		// 				},
		// 				{
		// 					"id": 16,
		// 					"name": "学校专业设置",
		// 					"url": "manageSystem/major/index",
		// 					"openStyle": 0,
		// 					"icon": "icon-edit-square"
		// 				},
		// 				{
		// 					"id": 17,
		// 					"name": "意向岗位设置",
		// 					"url": "manageSystem/post/index",
		// 					"openStyle": 0,
		// 					"icon": "icon-edit-square"
		// 				},
		// 				{
		// 					"id": 18,
		// 					"name": "正式岗位设置",
		// 					"url": "manageSystem/formal/index",
		// 					"openStyle": 0,
		// 					"icon": "icon-edit-square"
		// 				},
		// 				{
		// 					"id": 11,
		// 					"name": "菜单管理",
		// 					"url": "manageSystem/menu/index",
		// 					"openStyle": 0,
		// 					"icon": "icon-edit-square"
		// 				}
		// 			]
		// 		}
		// 	]
		// })
	})
}
